import { useQuery } from "@tanstack/react-query";
import { Moment } from "config";
import { API } from "config";

const useOrdersProductList = (
    page = 1,
    term = null,
    type = null,
    status = null,
    client = null,
    distributorId = null,
    order_by = null,
    period
) =>
    useQuery({
        queryKey: ["orders", page, term, type, status, client, distributorId, order_by, period],
        queryFn: async () => {
            // Validação simples do período
            if (!period || !Array.isArray(period) || period.length !== 2) {
                throw new Error("Período inválido");
            }

            const [startDate, endDate] = period;

            if (
                !startDate ||
                !endDate ||
                isNaN(new Date(startDate).getTime()) ||
                isNaN(new Date(endDate).getTime())
            ) {
                throw new Error("Datas inválidas no período");
            }

            // Formata para 'YYYY-MM-DD'
            const startFormatted = Moment(startDate).format("YYYY-MM-DD");
            const endFormatted = Moment(endDate).format("YYYY-MM-DD");

            const url =
                `/reports/products?page=${page}` +
                `&period[]=${startFormatted}` +
                `&period[]=${endFormatted}` +
                (term ? `&term=${term}` : "") +
                (type ? `&type=${type}` : "") +
                (status ? `&status=${status}` : "") +
                (client ? `&client=${client}` : "") +
                (distributorId ? `&distributor_id=${distributorId}` : "") +
                (order_by ? `&order_by=${order_by}` : "");

            const callback = await API.get(url);
            return callback?.data;
        },
    });

export default useOrdersProductList;
